// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const additionalRepair = claim =>
    dispatch => {

        dispatch({
            data: claim,
            type: actions.ADD_CLAIM_TRACK_ADDITIONAL_REPAIR
        });

        dispatch(routerActions.push('/claims/track/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/track/action-creators/additional-repair.js